<template>
  <div id="hrms74e">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            @setDataRowIndex="dataRow = arguments[0]"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :unLoadBool="true"
            :receivedStore="callSearchIndex"
            searchBoxAlias="hrms74e"
            :detailEvent="detailEvent"
            :approveEvent="approveEvent"
            :addInlineEventBool="!coursend"
            :deleteInlineEventBool="true"
            :saveInlineEvent="callSave"
            :columnEvent="columnEvent"
            :saveInlineBtnDisp="false"
            :approveInlineBtnDisp="!coursend"
            :deleteInlineBtnDisp="false"
            ref="hrms74eIndexSearchBoxTable" />
    <detail v-show="detailDisp"
            :labels="labels[dash.nowLang]"
            :labelsButton="dash.button[dash.nowLang]"
            :indexSelected="indexSelected"
            :nowLang="dash.nowLang"
            :toggle="toggle"
            :detail="detail"
            :tab2Table="columns[dash.nowLang].columnsTab2"
            :tab3Table="columns[dash.nowLang].columnsTab3" />

  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hrms74e/mutation-types'
import * as lovTypes from 'store/modules/hrmsLov/mutation-types'
import detail from 'components/hrms74e/detail'
import moment from 'moment'
import swal from 'sweetalert'

export default {
  name: 'hrms74e',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY'),
      dataRow: {},
      btn_approve: 'Approve',
      searchIndex: {},
      tempCodempid: []
    }
  },
  created () {
    this.receivedHrms74eColumnsLabels()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      popupLov: lovTypes.GET_LOV,
      indexDisp: types.GET_HRMS74E_INDEX_DISP,
      detailDisp: types.GET_HRMS74E_DETAIL_DISP,
      columns: types.GET_HRMS74E_COLUMNS,
      labels: types.GET_HRMS74E_LABELS,
      index: types.GET_HRMS74E_INDEX,
      indexSearchParams: types.GET_HRMS74E_INDEX_SEARCH_PARAMS,
      indexSelected: types.GET_HRMS74E_INDEX_SELECTED,
      detail: types.GET_HRMS74E_DETAIL,
      indexInlineData: types.GET_HRMS74E_INDEX_INLINE_DATA,
      coursend: types.GET_HRMS74E_COURSEND
    })
  },
  watch: {
    'searchIndex.nummemo' () {
      let dataRow = this.getDataRowPopupLovFromNummemo(this.searchIndex.nummemo, this.popupLov)
      if (dataRow) {
        this.dataRow = { nummemo: dataRow }
      }
    },
    'dataRow.nummemo' (newVal) {
      if (newVal) {
        this.searchIndex.codcours = newVal.codcours
        this.searchIndex.year = newVal.dteyear
        this.searchIndex.numclseq = newVal.numclseq
      }
    }
    // 'searchIndex.codcours' (newVal) {
    //   this.searchIndex.nummemo = this.getNummemo(this.searchIndex, this.popupLov)
    // },
    // 'searchIndex.year' (newVal) {
    //   this.searchIndex.nummemo = this.getNummemo(this.searchIndex, this.popupLov)
    // },
    // 'searchIndex.numclseq' (newVal) {
    //   this.searchIndex.nummemo = this.getNummemo(this.searchIndex, this.popupLov)
    // }
  },
  methods: {
    getDataRowPopupLovFromNummemo (nummemo, popupLov) {
      let nummemoFiltered = popupLov.nummemo.rows.filter((popupNummemo) => {
        return popupNummemo.nummemo === nummemo
      })
      return nummemoFiltered[0]
    },
    getNummemo (searchIndex, popupLov) {
      if (searchIndex.codcours && searchIndex.year && searchIndex.numclseq) {
        let nummemoFiltered = popupLov.nummemo.rows.filter((nummemo) => {
          return nummemo.codcours === searchIndex.codcours &&
                 parseInt(nummemo.dteyear) === parseInt(searchIndex.year) &&
                 nummemo.numclseq === searchIndex.numclseq
        })
        if (nummemoFiltered.length > 0) {
          return nummemoFiltered[0].nummemo || ''
        }
      }
      return ''
    },
    columnEvent (eventName, param, event) {
      let dataMap = this.index.rows.map(dataMap => {
        return dataMap.codempid
      })
      if (param.codempid !== '' && event.type === 'focusout') {
        if (this.tempCodempid.indexOf(param.codempid) === -1) {
          let validCodempid = true
          if (dataMap.indexOf(param.codempid) !== dataMap.lastIndexOf(param.codempid)) {
            validCodempid = false
            this.tempCodempid.push(param.codempid)
          }

          if (validCodempid) {
            let sendParams = {
              nummemo: this.searchIndex.nummemo,
              codcours: this.searchIndex.codcours,
              year: this.searchIndex.year,
              numclseq: this.searchIndex.numclseq
            }
            this.receivedHrms74eIndexAddInline({ searchParams: sendParams, param })
          } else {
            swal({
              title: 'ยืนยันการทำรายการ',
              text: 'รายการนี้ได้ถูกเลือกไปแล้ว'
            })
          }
        }
      }
      for (let newDataRow of this.tempCodempid) {
        if (dataMap.indexOf(newDataRow) === dataMap.lastIndexOf(newDataRow)) {
          let index = this.tempCodempid.indexOf(newDataRow)
          this.tempCodempid.splice(index, 1)
        }
      }
    },
    pageDetail (event) {
      let searchParams = {
        p_dteyear: this.indexSelected.dteyear,
        p_dtemonth: this.indexSelected.dtemonth,
        p_codcours: this.indexSelected.codcours,
        p_codempid_query: this.indexSelected.codempid
      }
      this.receivedHrms74eDetail(searchParams)
      this.toggle('detail')
    },
    detailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail()
    },
    approveEvent (dataRows) {
      let dataRowsFiltered = dataRows.filter(function (dataRow) {
        let staapprBool = false
        if (typeof dataRow.flgStaappr !== 'undefined') {
          staapprBool = (dataRow.flgStaappr !== 'P' && dataRow.flgStaappr.trim() !== '')
        }
        return staapprBool || dataRow.flgDelete || dataRow.flgAdd
      })
      if (dataRowsFiltered.length > 0) {
        for (let dataRow of dataRowsFiltered) {
          dataRow.flgEdit = true
        }
        this.$refs.hrms74eIndexSearchBoxTable.$emit('$searchBoxTableRef')
      } else {
        swal({
          title: 'ยืนยันการทำรายการ',
          text: 'รายการยังไม่ถูกเลือก'
        })
      }
    },
    callSave (dataRowsHasFlg) {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postHrms74eSendApprove({ searchIndex: this.searchIndex, dataRows: dataRowsHasFlg, codappr: this.codempid })
        }
      })
    },
    callSearchIndex (searchIndex) {
      if (this.searchIndex.nummemo !== '') {
        let dataRow = this.getDataRowPopupLovFromNummemo(this.searchIndex.nummemo, this.popupLov)
        if (dataRow) {
          this.dataRow = { nummemo: dataRow }
        } else {
          this.searchIndex.codcours = ''
          this.searchIndex.year = (new Date()).getFullYear()
          this.searchIndex.numclseq = ''
        }
      } else {
        this.searchIndex.nummemo = this.getNummemo(this.searchIndex, this.popupLov)
      }
      this.receivedHrms74eIndex(searchIndex)
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRMS74E_INDEX_SELECTED,
      setIndexInlineData: types.SET_HRMS74E_INDEX_INLINE_DATA
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRMS74E_PAGE,
      receivedHrms74eColumnsLabels: types.RECEIVED_HRMS74E_COLUMNS_LABELS,
      receivedHrms74eIndex: types.RECEIVED_HRMS74E_INDEX,
      receivedHrms74eIndexAddInline: types.RECEIVED_HRMS74E_INDEX_ADD_INLINE,
      receivedHrms74eDetail: types.RECEIVED_HRMS74E_DETAIL,
      postHrms74eSendApprove: types.POST_HRMS74E_SEND_APPROVE,
      postIndexSave: types.POST_HRMS74E_INDEX_SAVE
    })
  },
  components: {
    detail
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?017efe37